export default "__VITE_ASSET__P0mbCGyW__"